import * as React from 'react';
import {
    Project,
    VIEW_MODE,
    TENANT_LEVEL,
    PROJECT_STATUS
} from '@nexxt/common/types';
import {
    PROJECT_SUBTITLE_MAPPING,
    PROJECT_SUBTITLE_MAPPING_WIZARD,
    SITE_TITLE_MAPPING
} from '../../../mapping/router';
import { uppercaseFirstLetter } from '@nexxt/common/services/TextService';
import { getUserDetails } from '@nexxt/common/firebase/auth/userDetails';
import { ILocation } from '../../../interface/common.interface';
import { PROJECT } from '../../../constants/routes';
import HelperTooltip from '../HelperTooltip';

interface PageTitleProps {
    pathname: string;
    project?: Project;
    viewMode?: VIEW_MODE;
    location?: ILocation;
}

const PageTitle: React.FC<PageTitleProps> = (props: PageTitleProps) => {
    const userDetails = getUserDetails();
    const isWizard =
        userDetails.defaultTenant.tenantLevel === TENANT_LEVEL.INCA_WIZARD;

    const subtitleMapping = isWizard
        ? PROJECT_SUBTITLE_MAPPING_WIZARD
        : PROJECT_SUBTITLE_MAPPING;

    const pathChunks = props.location?.pathname?.split('/');
    // only show project title if UNDER the project directory hierarchy
    if (
        props.project &&
        props.pathname.includes(PROJECT) &&
        pathChunks?.filter((x) => x).length >= 2
    ) {
        return (
            <>
                <div
                    className="flex"
                    style={{
                        alignItems: 'center'
                    }}
                >
                    <p className="page--title">{props.project.name}</p>
                    {props.project.id && (
                        <>
                            <div className="project-status--block">
                                <span
                                    className={`project-status project-status--${
                                        props.project?.status?.toLowerCase() ||
                                        PROJECT_STATUS.DRAFT
                                    }`}
                                ></span>
                                <span>
                                    {uppercaseFirstLetter(
                                        props.project?.status ||
                                            PROJECT_STATUS.DRAFT
                                    )}
                                </span>
                            </div>
                            {props.viewMode === VIEW_MODE.DEV && (
                                <div className="project-status--block">
                                    <span
                                        className={`project-status-badge project-status--dev`}
                                    >
                                        DEV
                                    </span>
                                </div>
                            )}
                        </>
                    )}
                </div>
                <HelperTooltip
                    pathname={
                        PROJECT_SUBTITLE_MAPPING[
                            props.pathname.replace(
                                props.project.id,
                                ':projectId'
                            )
                        ]
                    }
                    placement="bottom"
                    textSize="large"
                >
                    <p className="page--subtitle">
                        {
                            PROJECT_SUBTITLE_MAPPING[
                                props.pathname.replace(
                                    props.project.id,
                                    ':projectId'
                                )
                            ]
                        }
                    </p>
                </HelperTooltip>
            </>
        );
    }
    const pageTitle =
        SITE_TITLE_MAPPING(userDetails?.firstName || 'there')[props.pathname] ||
        props.pathname.split('/')[1];

    return (
        <>
            <p className="page--title">{pageTitle}</p>
            <HelperTooltip
                pathname={
                    props.location.state?.solution
                        ? props.location.state?.solution.title
                        : subtitleMapping[props.pathname]
                }
                placement="bottom"
                textSize="large"
            >
                <p className="page--subtitle">
                    {props.location.state?.solution
                        ? props.location.state?.solution.title
                        : subtitleMapping[props.pathname]}
                </p>
            </HelperTooltip>
        </>
    );
};

export default PageTitle;
